import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar-wedget-wrap" }
const _hoisted_2 = { class: "sidebar-wedget" }
const _hoisted_3 = { class: "ps-0 mb-0 list-unstyled popular-post" }
const _hoisted_4 = { class: "flex-shrink-0" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = { class: "d-flex align-items-center mb-1" }
const _hoisted_8 = { class: "text-body ms-1" }
const _hoisted_9 = { style: {"font-size":"14px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"sidebar-wedget\"><span class=\"top-title\">البحث في المقالات</span><form class=\"search-form position-relative z-1\"><input type=\"text\" class=\"form-control\" placeholder=\"ابحث هنا...\"><button class=\"src-btn position-absolute top-50 end-0 translate-middle-y\"><i class=\"ri-search-line\"></i></button></form></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "top-title" }, "مقالات شائعة", -1)),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popularBlogs, (blog) => {
          return (_openBlock(), _createElementBlock("li", {
            key: blog.id
          }, [
            _createVNode(_component_RouterLink, {
              to: `/blog-details/${blog.id}`,
              class: "d-flex align-items-center"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: blog.image,
                    alt: blog.title,
                    style: {"width":"80px","height":"60px","object-fit":"cover"}
                  }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ti ti-calendar-week" }, null, -1)),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(blog.date), 1)
                  ]),
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(blog.title), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ])
  ]))
}